import { classNames } from "../utils";
interface PaginationProps {
  totalCount: number;
  currentPage: number;
  pageSize: number;
  showDescription?: boolean;
  pageChange?: (idx: number) => void;
  activeStyle?: string;
  unfilteredCount?: number;
  clearFilters?: () => void;
}

const PaginationInMemory = ({
  totalCount,
  currentPage,
  pageSize,
  showDescription,
  pageChange,
  activeStyle = "underline",
  unfilteredCount,
  clearFilters,
}: PaginationProps) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  const startRow = (currentPage - 1) * pageSize + 1;
  const endRow = Math.min(startRow + pageSize - 1, totalCount);
  const center = [
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
    ],
    filteredCenter: Array<string | number> = center.filter(
      (p) => p > 1 && p < totalPages
    ),
    includeThreeLeft = currentPage === 5,
    includeThreeRight = currentPage === totalPages - 4,
    includeLeftDots = currentPage > 5,
    includeRightDots = currentPage < totalPages - 4;

  if (includeThreeLeft) {
    filteredCenter.unshift(2);
  }
  if (includeThreeRight) {
    filteredCenter.push(totalPages - 1);
  }

  if (includeLeftDots) {
    filteredCenter.unshift("...");
  }
  if (includeRightDots) {
    filteredCenter.push("...");
  }
  const iterate = totalPages <= 1 ? [] : [1, ...filteredCenter, totalPages];
  return (
    <>
      <div className="flex flex-wrap items-center mt-5 text-sm">
        {iterate.map((el, idx) =>
          typeof el !== "number" ? (
            <span
              className="flex justify-center items-center w-10 h-9 border bg-white shadow font-medium text-gray-600"
              key={`dots${idx}`}
            >
              ...
            </span>
          ) : (
            <div key={`num${el}`}>
              <span
                id="next"
                className={classNames(
                  "flex justify-center items-center w-10 h-9 border shadow",
                  "font-medium text-gray-600 cursor-pointer",
                  currentPage === el ? activeStyle : "bg-white"
                )}
                onClick={() => pageChange?.(el)}
                key={el.toString() + idx.toString()}
              >
                {el}
              </span>
            </div>
          )
        )}
        {showDescription && (
          <p className="text-gray-600 mx-6">
            Showing Page
            <span className="mx-2 font-semibold">{currentPage}</span>of
            <span className="mx-2 font-semibold">{totalPages}</span>with rows
            <span className="mx-2 font-semibold">{startRow}</span>-
            <span className="mx-2 font-semibold">{endRow}</span>of
            <span className="mx-2 font-semibold">{totalCount}</span>
            {unfilteredCount && unfilteredCount > 0 && (
              <span>
                ({unfilteredCount} unfiltered
                {clearFilters && totalCount < unfilteredCount && (
                  <span
                    className="m-2 text-red-500"
                    onClick={() => clearFilters()}
                  >
                    CLEAR ALL
                  </span>
                )}
                )
              </span>
            )}
          </p>
        )}
      </div>
    </>
  );
};

export default PaginationInMemory;
